export default "__VITE_ASSET__adcb397a__"